<div class="row" id="civil-print-confirm-modal">
    <div class="col-md-12">  
        <div class="modal-content">
            <div class="modal-header modal-header-no-banner" id="printmodalheader">
                <h3 class="modal-title">Follow these steps to print case information:
                    <span class="pull-right row" style="padding-right: 20px;">
                        <button id="print.close" class="btn btn-primary btn-ciprs" (click)="hideModal()" style="margin-bottom: 5px">
                            Close&nbsp;&nbsp;<span class="fa fa-close"></span>
                        </button>
                    </span>
                </h3>
            </div>

            <div class="modal-body">
                <br>
                <div class="row">
                    <ul>
                        <li class="col-xs-offset-2 col-xs-3 no-padding" (click)="goToStep(1)"
                                [ngClass]="{'clickable-step': currentStep > 1, 'active-step': currentStep === 1}"
                        ></li>
                        <li class="col-xs-3 no-padding" (click)="goToStep(2)"
                            [ngClass]="{'clickable-step': currentStep > 2, 'active-step': currentStep === 2}"
                        ></li>
                        <li class="col-xs-3 no-padding" (click)="goToStep(3)"
                            [ngClass]="{'active-step': currentStep === 3}"></li>
                    </ul>
                </div>
                <br>
                <div class="row">
                    <div class="col-xs-offset-1 col-xs-3 no-padding"
                            [ngClass]="{'active-step': currentStep === 1, 'clickable-step': currentStep > 1}"
                            (click)="goToStep(1)">
                        Step 1 - Confirm selection
                    </div>
                    <div id="print-step2-label" class="col-xs-3 no-padding"
                            [ngClass]="{'active-step': currentStep === 2, 'clickable-step': currentStep > 2}"
                            (click)="goToStep(2)">
                        Step 2 - Print
                    </div>
                    <div class="col-xs-3 no-padding"
                        [ngClass]="{'active-step': currentStep === 3}"
                        (click)="goToStep(3)">
                        Step 3 - Continue or clear history?
                    </div>
                </div>
                
                    <div *ngIf="currentStep === 1">
                            <br>
                            <div id='civil-print-table-wrapper-div' class="table-responsive">
                            <table class="table table-condensed" id="civil-print-table">
                                <thead>
                                    <tr>
                                        <th class="col-md-8">Case Caption</th>
                                        <th class="col-md-2">Case County</th>
                                        <th class="col-md-2">Case Number</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let case of getCases()">
                                        <td>{{case.getCaseCaption()}}</td>
                                        <td>{{case.getCaseCounty()}}</td>
                                        <td>{{case.getCaseNumber()}}</td>
                                    </tr>
                                </tbody>
                            </table>
                            </div>
                            <br>
                            <div class="well" id="civil-print-step1-table-footer-text">
                                <div class="inline-block">
                                    <i class="fa fa-exclamation-circle fa-2x exclamation" id="civil-print-step1-warning-text-exclamation"></i>
                                </div>
                                <div class="inline-block" id="civil-print-step1-warning-text">
                                    Printing may require payment for each page printed. You can also email the information free of charge. To use email, close this wizard and select the Email button.
                                </div>
                            </div>
                            <hr>    
                        <button class="btn btn-ciprs btn-primary center-block"  id="civil-print-gen-pdf" (click)="printConfirm()"
                        [disabled]="isHttpRequestInProgress()" 
                        style="margin-top:10px"><span title="Step 1 - Confirm selection">Confirm</span></button>
                        <div *ngIf="isHttpRequestInProgress()">
                            <h3 class="text-center">
                                <p style="opacity: 0.6;">Creating Document...</p>
                                <i class="fa fa-spinner fa-pulse fa-2x text-center"></i>                        
                            </h3>    
                        </div>
                        <div style="margin-top:10px" [hidden]="!errors.length">
                            <alert type="danger" *ngFor="let error of errors">{{error}}</alert> 
                        </div>
                    </div>
                    <div *ngIf="currentStep === 2">
                        <div *ngIf="pdfUri"  id="civil-print-pdf" height="500px" width="98%">
                            <app-pdf [pdfUri]="pdfUri"></app-pdf>
                        </div>
                        <div class="instruction">To print, select the printer icon displayed when you move the mouse over the document. Depending on your county's policy, you may be required to pay for each printed page. To print only the desired pages in the displayed document, enter the page numbers in the "Pages" field using the format indicated in the field.</div>
                        <button class="btn btn-ciprs btn-primary  center-block"  style="margin-top:10px"
                        (click)="donePrinting()" id="civil-done-printing"><span title="Step 2 - Print">I'm Done Printing</span></button>
                    </div>
                    <div *ngIf="currentStep === 3">
                        Click 'Continue' if you want to keep using this application.  Click 'Clear History' to clear your search history and remove any data in your cart.
                        <hr>
                        <div class="center-block" style="width: 240px;">
                            <button class="btn btn-ciprs btn-primary" (click)="continue()" id="civil-print-continue"><span title="Step 3 - Continue or clear history?">Continue</span></button>
                            <button class="btn btn-ciprs btn-primary" (click)="clearHistory()" id="civil-print-clear-history"><span title="Step 3 - Continue or clear history?">Clear History</span></button>
                        </div>    
                    </div>
                
            </div>
        </div>
    </div>
</div>



// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/print/print.component.html